import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NewsFeedItemContentBase } from '@fi-app/news-feed/news-feed-item-content/news-feed-item-content-base';
import { AppTextService } from '@fi-shared/app-text';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { FiDateTimeFormatOptions } from '@fi-shared/utils';

@Component({
    selector: 'fi-news-feed-item-content-pk',
    templateUrl: './news-feed-item-content-pk.component.html',
    styleUrls: ['./news-feed-item-content-pk.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-news-feed-item-content-pk' },
    standalone: false,
})
export class NewsFeedItemContentPkComponent extends NewsFeedItemContentBase {
    getPKLogFeedItemTitle() {
        const changedOn = this.fiFormatDateService.formatDate(this.newsItem.ChangedOn, FiDateTimeFormatOptions, {
            showToday: false,
        });
        return this.appTextService.get('pk.news_feed_title', {
            '{0}': changedOn,
        });
    }

    getPKLogFeedItemErrorText() {
        if (this.newsItem.Content.ErrorMessage) {
            return this.appTextService.get('pk.news_feed_unexpected_error');
        }
        return this.appTextService.get('pk.news_feed_failed_users_error', {
            '{n}': this.newsItem.Content.FailedUsersCount,
        });
    }
}
